import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {CommunicationService} from '../services/communication.service';
import {ResetPasswordData, ResetPasswordResponse} from './change-password.domain';

@Injectable()

export class ChangePasswordService {
  constructor(private communicationService: CommunicationService) {
  }

  updatePassword(requestData: ResetPasswordData): Observable<ResetPasswordResponse> {
    return this.communicationService.updateData('registration', requestData);
  }
}
